import * as _ from 'lodash';
import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationService } from '@app/services/notification.service';
import { ErrorCodes, enumCodesErrors } from '../components/error/error.code';
import { SnackbarService } from '@app/services/snackbar.service';
import { HttpErrorComponent } from '@app/components/http-error/http-error.component';
import { of, throwError } from 'rxjs';

export class Error {
    matcher: RegExp;
    message: string;
}

export interface SynappsErrorMessage {
    error: {
        id: string;
        status: number;
        title: string;
        detail: string;
    };
};

@Injectable()
export class ErrorService {


    public projectServiceErrors: Error[] = [
        {
            matcher: /"guaranteedReplyTime" must be a number/,
            message: 'GTI non valide'
        },
        {
            matcher: /"guaranteedReplyTimeNbh" must be a number/,
            message: 'GTI (HNO) non valide'
        },
        {
            matcher: /"guaranteedResponseTime" must be a number/,
            message: 'GTR (HO) non valide'
        },
        {
            matcher: /"guaranteedResponseTimeNbh" must be a number/,
            message: 'GTR (HNO) non valide'
        },
        {
            matcher: /must be larger than or equal to 0/,
            message: 'La GTI / GTR ne peut pas être inférieure à 0'
        },
        {
            matcher: /Invalid project name/g,
            message: 'Le nom du projet est invalide'
        },
        {
            matcher: /Id already exists/g,
            message: 'L\'identifiant existe déjà'
        },
        {
            matcher: /Project name already exists/g,
            message: 'Le nom du projet existe déjà'
        },
        {
            matcher: /Duplicate fields are not allowed/g,
            message: 'Un des champs est déjà utilisé par un autre projet et n\'est pas autorisé à être dupliqué'
        },
        {
            matcher: /Project creation failed/g,
            message: 'La création du projet a échoué'
        },
        {
            matcher: /Project update failed/g,
            message: 'La mise à jour du projet a échoué'
        },
        {
            matcher: /Project deletion failed/g,
            message: 'La suppression du projet a échoué'
        },
        {
            matcher: /Project does not exist/g,
            message: 'Le projet n\'existe pas ou a été supprimé'
        },
        {
            matcher: /Missing business code/g,
            message: 'Il manque le code affaire / BPJ'
        },
        {
            matcher: /Missing business label/g,
            message: 'Il manque le libellé du BPJ'
        },
        {
            matcher: /Client can't be a partner/g,
            message: 'Un client ne peut pas être partenaire'
        },
        {
            matcher: /Insufficient project privileges/g,
            message: 'Privilèges sur les projets insuffisants'
        },
        {
            matcher: /"documentUri" must be a valid uri/g,
            message: 'Le lien vers la documentation du projet n\'est pas valide'
        },
        {
            matcher: /Project is linked to an active inventory/g,
            message: 'Le projet est encore relié à un inventaire actif'
        }
    ];

    public assignmentGroupConfigErrors: Error[] = [];

    public serviceCatalogErrors: Error[] = [];

    public slaPeriodErrors: Error[] = [
    ];

    public userServiceErrors: Error[] = [
        {
            matcher: /User name is invalid/g,
            message: 'Le nom de l\'utilisateur est invalide'
        },
        {
            matcher: /User id already exists/g,
            message: 'L\'identifiant de l\'utilisateur existe déjà'
        },
        {
            matcher: /Email already exists/g,
            message: 'Création du contact impossible, l\'adresse mail de ce contact existe déjà dans SynApps'
        },
        {
            matcher: /Duplicate fields are not allowed|Duplicate field not allowed/g,
            message: 'Un des champs est déjà utilisé par un autre utilisateur et n\'est pas autorisé à être dupliqué'
        },
        {
            matcher: /Could not create user/g,
            message: 'La création de l\'utilisateur a échoué'
        },
        {
            matcher: /User update failed/g,
            message: 'La mise à jour de l\'utilisateur a échoué'
        },
        {
            matcher: /User does not exist/g,
            message: 'L\'utilisateur n\'existe plus dans la base de données'
        },
        {
            matcher: /User does not have sufficient privileges to modify an internal user/g,
            message: 'Vous n\'avez pas les privilèges suffisants pour modifier un utilisateur interne'
        },
        {
            matcher: /The user does not have at least one role on the project. He can not have communications on it./g,
            message: 'L\'utilisateur n\'a aucun rôle sur le projet, il ne peut pas avoir de communications à ce sujet'
        },
        {
            matcher: /The company is mandatory for external user./g,
            message: 'La société est obligatoire pour les utilisateurs externes'
        },
        {
            matcher: /Unable to get list of users/g,
            message: 'Impossible de récupérer la liste des utilisateurs'
        },
        {
            matcher: /An external user can not have a claranet email./g,
            message: 'Un utilisateur externe ne peut pas avoir une adresse Email Claranet'
        },
        {
            matcher: /An external user can not have a role on every \(\*\) project or role 'admin'/g,
            message: 'Un utilisateur externe ne peut pas avoir de rôle global sur tous les projets ou de rôle \'admin\''
        },
        {
            matcher: /External user can not give project access if they do not have it himself/g,
            message: 'Un utilisateur externe ne peut pas donner accès à un projet s\'il ne l\'a pas lui-même'
        },
        {
            matcher: /"email" must be a valid email/g,
            message: 'L\'adresse Email n\'est pas valide'
        },
        {
            matcher: /"workPhone" is not a valid E.164 phone number/g,
            message: 'Le numéro de téléphone n\'est pas valide, il doit être au format +XX'
        },
        {
            matcher: /"language" is not a valid language code/g,
            message: 'La langue n\'est pas au bon format'
        }
    ];

    public companyServiceErrors: Error[] = [
        {
            matcher: /Id already exists/g,
            message: 'L\'identifiant de la société existe déjà'
        },
        {
            matcher: /Name already exists/g,
            message: 'Le nom de la société existe déjà'
        },
        {
            matcher: /Duplicate fields are not allowed/g,
            message: 'Un des champs est déjà utilisé par une autre société et n\'est pas autorisé à être dupliqué'
        },
        {
            matcher: /Company creation failed/g,
            message: 'La création de la société a échoué'
        },
        {
            matcher: /Company update failed/g,
            message: 'La mise à jour de la société a échoué'
        },
        {
            matcher: /Company does not exist/g,
            message: 'La société n\'existe plus dans la base de données'
        },
        {
            matcher: /Invalid user id provided/g,
            message: 'Un des utilisateurs utilisé n\'est pas valide'
        },
        {
            matcher: /customer company/g,
            message: 'Impossible de supprimer une société cliente'
        },
        {
            matcher: /company with users/g,
            message: 'Impossible de supprimer une société comportant des utilisateurs'
        },
        {
            matcher: /company with projects/g,
            message: 'Impossible de supprimer une société associé à des projets'
        },
        {
            matcher: /Insufficient company privileges/g,
            message: 'Vous n\'avez pas les bons privilèges dans la société pour faire ceci'
        }
    ];

    public inventoryServiceErrors: Error[] = [
        {
            matcher: /Invalid name/g,
            message: 'Le nom de l\'inventaire est invalide'
        },
        {
            matcher: /Id already exists/g,
            message: 'L\'identifiant de l\'inventaire existe déjà'
        },
        {
            matcher: /Name already exists/g,
            message: 'Le nom de l\'inventaire existe déjà'
        },
        {
            matcher: /Duplicate fields are not allowed/g,
            message: 'Un des champs est déjà utilisé par un autre inventaire et n\'est pas autorisé à être dupliqué'
        },
        {
            matcher: /Inventory creation failed/g,
            message: 'La création de l\'inventaire a échoué'
        },
        {
            matcher: /Inventory update failed/g,
            message: 'La mise à jour de l\'inventaire a échoué'
        },
        {
            matcher: /Inventory does not exist/g,
            message: 'L\'inventaire n\'existe plus dans la base de données'
        }
    ];

    public cellServiceErrors: Error[] = [
        {
            matcher: /Invalid name/g,
            message: 'Le nom de la cellule est invalide'
        },
        {
            matcher: /Id already exists/g,
            message: 'L\'identifiant de la cellule existe déjà'
        },
        {
            matcher: /Name already exists/g,
            message: 'Le nom de la cellule existe déjà'
        },
        {
            matcher: /Duplicate fields are not allowed/g,
            message: 'Un des champs est déjà utilisé par une autre cellule et n\'est pas autorisé à être dupliqué'
        },
        {
            matcher: /Cell creation failed/g,
            message: 'La création de la cellule a échoué'
        },
        {
            matcher: /Cell update failed/g,
            message: 'La mise à jour de la cellule a échoué'
        },
        {
            matcher: /Cell does not exist/g,
            message: 'La cellule n\'existe plus dans la base de données'
        }
    ];

    public tribeServiceErrors: Error[] = [
        {
            matcher: /Invalid name/g,
            message: 'Le nom de la tribu est invalide'
        },
        {
            matcher: /Id already exists/g,
            message: 'L\'identifiant de la tribu existe déjà'
        },
        {
            matcher: /Name already exists/g,
            message: 'Le nom de la tribu existe déjà'
        },
        {
            matcher: /Duplicate fields are not allowed/g,
            message: 'Un des champs est déjà utilisé par une autre tribu et n\'est pas autorisé à être dupliqué'
        },
        {
            matcher: /Tribes creation failed/g,
            message: 'La création de la tribes a échoué'
        },
        {
            matcher: /Tribes update failed/g,
            message: 'La mise à jour de la tribes a échoué'
        },
        {
            matcher: /Tribes does not exist/g,
            message: 'La tribu n\'existe plus dans la base de données'
        }
    ];

    public factoryServiceErrors: Error[] = [
    ];

    public appServiceErrors: Error[] = [
        {
            matcher: /Invalid name/g,
            message: 'Le nom de l\'application est invalide'
        },
        {
            matcher: /Id already exists/g,
            message: 'L\'identifiant de l\'application existe déjà'
        },
        {
            matcher: /Name already exists/g,
            message: 'Le nom de l\'application existe déjà'
        },
        {
            matcher: /Duplicate fields are not allowed/g,
            message: 'Un des champs est déjà utilisé par une autre application et n\'est pas autorisé à être dupliqué'
        },
        {
            matcher: /App creation failed/g,
            message: 'La création de l\'application a échoué'
        },
        {
            matcher: /App update failed/g,
            message: 'La mise à jour de l\'application a échoué'
        },
        {
            matcher: /App does not exist/g,
            message: 'l\'application n\'existe plus dans la base de données'
        }
    ];

    public accountingSageServiceErrors: Error[] = [
        {
            matcher: /Cannot find customer detail/g,
            message: 'Impossible de trouver les détails du client'
        },
        {
            matcher: /Cannot find customer/g,
            message: 'Impossible de trouver le client'
        },
        {
            matcher: /Cannot find business codes/g,
            message: 'Impossible de trouver les codes affaire / BPJ'
        },
        {
            matcher: /Cannot find business code'/g,
            message: 'Impossible de trouver le code affaire / BPJ'
        },
        {
            matcher: /Cannot find subscriptions/g,
            message: 'Impossible de trouver les abonnements'
        },
    ];

    public gdprServiceErrors: Error[] = [
        {
            matcher: /Id already exists/g,
            message: 'L\'identifiant RGPD existe déjà'
        },
        {
            matcher: /Duplicate fields are not allowed/g,
            message: 'Un des champs est déjà utilisé par un autre RGPD et n\'est pas autorisé à être dupliqué'
        },
        {
            matcher: /Gdpr creation failed/g,
            message: 'La création du RGPD a échoué'
        },
        {
            matcher: /Gdpr update failed/g,
            message: 'La mise à jour du RGPD a échoué'
        },
        {
            matcher: /Gdpr does not exist/g,
            message: 'Le RGPD n\'existe plus dans la base de données'
        },
        {
            matcher: /Project does not exist/g,
            message: 'Le projet associé à ce RGPD n\'existe pas'
        },
        {
            matcher: /Project is desactivated/g,
            message: 'Le projet associé à ce RGPD est désactivé'
        }
    ];

    public ticketServiceErrors: Error[] = [
        {
            matcher: /Comment with status NEW can not be resolved./,
            message: 'Un ticket au status Nouveau ne peut pas être résolu'
        },
        {
            matcher: /"assignmentGroup" must be a string/,
            message: 'Le groupe d\'assignement est requis'
        },
        {
            matcher: /Project does not exist/g,
            message: 'Le projet n\'existe pas'
        },
        {
            matcher: /Ticket does not exist/g,
            message: 'Le ticket n\'existe pas'
        },
        {
            matcher: /User does not have any project privileges|Insufficient project privileges./g,
            message: 'Privilèges insuffisants sur le ou les projet(s)'
        },
        {
            matcher: /projectId is required/,
            message: 'L\'id de projet est manquant'
        },
        {
            matcher: /assignmentGroup does not exist/,
            message: 'Le groupe d\'assignement n\'existe pas'
        },
        {
            matcher: /"subject" is required/,
            message: 'Le sujet est requis'
        },
        {
            matcher: /"description" is required/,
            message: 'La description est requise'
        },
        {
            matcher: /assignmentGroup is required/,
            message: 'Le groupe d\'assignement est requis'
        },
        {
            matcher: /type is required/,
            message: 'Le type est requis'
        },
        {
            matcher: /"impact" must be one of/,
            message: 'L\'impact est requis'
        },
        {
            matcher: /"request" is required/,
            message: 'Le type de demande est requis'
        },
        // comment
        {
            matcher: /status value not allowed/,
            message: 'Le type de demande est requis'
        },
        {
            matcher: /body is required/,
            message: 'Le commentaire est invalide'
        },
        // attachment
        {
            matcher: /Attachment does not exist/,
            message: 'La pièce jointe n\'existe pas'
        },
        {
            matcher: /contentType is required/,
            message: 'L\'extension de la pièce jointe n\'est pas supportée'
        },
        {
            matcher: /Upload attachment failed/,
            message: 'L\'extension de la pièce jointe n\'est pas supportée'
        },
        // global
        {
            matcher: /Ticket does not exist/,
            message: 'Le ticket n\'existe pas'
        },
        {
            matcher: /User does not have any project privileges|Insufficient project privileges./,
            message: 'Privilèges sur le ticket insuffisants'
        },
        {
            matcher: /\"project\" must be a string/,
            message: 'Le projet est requis'
        }
    ];

    public businessProjectsServiceErrors: Error[] = [
        {
            matcher: /Business Project does not exist/g,
            message: 'Le Business Project n\'existe pas'
        },
        {
            matcher: /Business project creation failed/g,
            message: 'La création du Business Project a échoué'
        },
        {
            matcher: /Business project update failed/g,
            message: 'La mise à jour du Business Project a échoué'
        },
        {
            matcher: /Unable to parse your request/g,
            message: 'Requête invalide pour le recherche de Business Projects'
        },
        {
            matcher: /Cannot rename business project/g,
            message: 'Impossible de renommer un Business Project'
        },
        {
            matcher: /Could not find some of the clients associated with this business project/g,
            message: 'Une partie des clients associés au Business Project n\'a pas été trouvée'
        },
    ];

    public globalSearchServiceErrors: Error[] = [];

    public roleServiceErrors: Error[] = [];

    public userSessionServiceErrors: Error[] = [];

    public auditServiceErrors: Error[] = [];

    constructor(
        private notificationService: NotificationService,
        private snackbarService: SnackbarService,
        private router: Router
    ) { }

    public errorHandler<T>(errorList: { matcher: RegExp; message: string }[], operation = 'operation', result?: T, shouldThrowError = false) {
        return async (response: HttpErrorResponse): Promise<T> => {
            if (!response?.error?.error) {
                if (response.name === 'HttpErrorResponse') {
                    // eslint-disable-next-line
                    await this.router.navigate(['/error'], { queryParams: { code: ErrorCodes.fail_to_reach_api } });
                }
                return new Promise(resolve => {
                    throwError(() => response).subscribe(
                        {
                            next: (data) => {
                                resolve(data);
                            }
                        });
                });
            }
            if (shouldThrowError) {
                return new Promise(resolve => {
                    throwError(() => response).subscribe(
                        {
                            next: (data) => {
                                resolve(data);
                            }
                        });
                });
            }

            const detail: string = response.error.error.detail;
            let message = detail;

            _.eachRight(errorList, (error) => {
                if (detail.match(error.matcher)) {
                    message = error.message;
                    return false;
                }
            });
            message = message || this.getErrorByStatus(response.error.error.status);

            this.snackbarService.openFromComponent(HttpErrorComponent, {
                data: { message: `Erreur : ${operation} (${message})`, meta: response.error.error.meta },
                options: { type: 'danger', timeout: message.length > 50 ? 7000 : 5000 }
            });

            this.notificationService.addNotification({
                type: 'danger',
                title: `${operation} (${message})`,
                description: `${response.name} for ${response.url}`,
                code: response.status,
                correlationId: response.error.error.id,
                meta: response.error.error.meta,
            });

            return new Promise(resolve => {
                of(result as T).subscribe(
                    {
                        next: (data) => {
                            resolve(data);
                        }
                    });
            });
        };
    }

    private getErrorByStatus(status: number): string {
        return enumCodesErrors[status] || enumCodesErrors.UNKNOWN;
    }

}
